export default {
    layout: 'Login'
}